// Proven Tasks are curated/shared Tasks — owned by super-admin or an agency,
// never by a single chat user. They must never be created, edited, or
// deleted by a chat user; "Automate" always clones them into a new Task.
export const PROVEN_TASK_TYPES = ["SuperAdmin", "super-admin", "agency"];

export const isProvenTask = (task) =>
  PROVEN_TASK_TYPES.includes(String(task?.type));
